<template>
  <CustomVoiceSelector
    :model-value="selectedVoiceId"
    :accent="accent"
    :accentEnabled="accentEnabled === true"
    :placeholder="t('phoneVoiceSelector.selectVoice')"
    :voiceType="voiceType"
    :voiceFilterMode="voiceFilterMode"
    :agentLanguage="agentLanguage"
    @update:model-value="handleUpdate"
    @update:accent="handleAccentUpdate"
  />
</template>

<script setup>
import { useI18n } from '@/i18n';
import CustomVoiceSelector from './CustomVoiceSelector.vue';

const props = defineProps({
  selectedVoiceId: { type: String, default: '' },
  accent: { type: String, default: '' },
  accentEnabled: { type: Boolean, default: false },
  voiceType: { type: String, default: '' },
  voiceFilterMode: { type: String, default: '' },
  agentLanguage: { type: String, default: '' }
});

const emit = defineEmits(['update:selectedVoiceId', 'update:accent']);
const { t } = useI18n();

function handleUpdate(value) {
  emit('update:selectedVoiceId', value);
}

function handleAccentUpdate(value) {
  if (props.accentEnabled === true) {
    emit('update:accent', value);
  }
}
</script>
